const PAYMENT_EVENT = 'client:subscriptionPayment';
const PRODUCTS_LIMITATION_EVENT = 'client:importProductsLimitation';

export const EVENTS = {
  PAYMENT_EVENT,
  PRODUCTS_LIMITATION_EVENT
};